export default function LembrarSenha() {
  
    function showPasswordResetModal() {
        const modal = document.getElementById("id-password-reset");
        modal.style.display = "block";
    }

    function hidePasswordResetModal() { 
        const modal = document.getElementById("id-password-reset");
        modal.style.display = "none";
    }
   // Substitua pelo seletor do elemento pai

    // Adiciona um event listener ao elemento pai
    document.addEventListener("click", function (event) {
        // Verifica se o elemento clicado é o #lembrarSenhaLink
        if (event.target.matches("#lembrarSenhaLink")) {
            event.preventDefault();
            showPasswordResetModal();
        }
    });
   


    document.querySelector(".modal-close")?.addEventListener("click", function () {
        hidePasswordResetModal();
    });

    window.addEventListener("click", function (event) {
        const modal = document.getElementById("id-password-reset");
        if (event.target === modal) {
            hidePasswordResetModal();
        }
    });
}
